import { getMobileDeviceStatistics } from '../services/getMobileDeviceStatistics';
import { getCASMailbox2 } from '../services/getCASMailbox2';
import { initMobileDeviceFullStore } from '../mutators/initMobileDeviceFullStore';

export async function initMobileDeviceFullOption(): Promise<boolean> {
    let getCASMailbox2Response = await getCASMailbox2();
    let getMobileDeviceStatisticsResponse = await getMobileDeviceStatistics();

    if (!getCASMailbox2Response.ErrorMessage && !getMobileDeviceStatisticsResponse.ErrorMessage) {
        initMobileDeviceFullStore(
            getMobileDeviceStatisticsResponse.MobileDeviceStatisticsCollection.MobileDevices,
            getCASMailbox2Response.Options
        );

        return true;
    }

    return false;
}
